import { render, staticRenderFns } from "./BrandsManager.vue?vue&type=template&id=4e964ada&scoped=true"
import script from "./BrandsManager.vue?vue&type=script&lang=js"
export * from "./BrandsManager.vue?vue&type=script&lang=js"
import style0 from "./BrandsManager.vue?vue&type=style&index=0&id=4e964ada&prod&lang=scss"
import style1 from "./BrandsManager.vue?vue&type=style&index=1&id=4e964ada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e964ada",
  null
  
)

export default component.exports